import React from "react";
import {
  defineBlock,
  smartProps,
  EditableImg,
  useSmartProp,
  useInspectorControl,
  ChildrenBlock,
  useEditor,
} from "@smartfire/gutenberg-react";
import { PanelBody, PanelRow, ToggleControl } from "@wordpress/components";
import style from "./block.module.scss";
import EditableText from "../shared/editable-text";
import { ReactComponent as Bouteille } from "../assets/bouteilleIcon.svg";
import { InnerBlocks } from "@wordpress/block-editor";

function Inspector() {
  const [disposition, setDisposition] = useSmartProp("disposition");
  const [separateur, setSeparateur] = useSmartProp("separateur");
  return (
    <>
      <PanelBody title="Configuration sens bloc" initialOpen={true}>
        <PanelRow>
          <ToggleControl
            label="Alignement / Disposition"
            help={disposition === "left" ? "Texte à gauche" : "Texte à droite"}
            checked={disposition === "left"}
            onChange={() =>
              disposition === "left"
                ? setDisposition("right")
                : setDisposition("left")
            }
          />
        </PanelRow>
      </PanelBody>
      <PanelBody title="Séparateur" initialOpen={true}>
        <PanelRow>
          <ToggleControl
            label="Présence séparateur en bas"
            help={separateur ? "Présence Séparateur" : "Pas de séparateur"}
            checked={separateur}
            onChange={() =>
              separateur ? setSeparateur(false) : setSeparateur(true)
            }
          />
        </PanelRow>
      </PanelBody>
    </>
  );
}

function Block({ disposition, separateur }) {
  useInspectorControl(Inspector);
  const { isEditing } = useEditor();
  return (
    <div className={style.block}>
      <div className={disposition === "left" ? style.left : style.right}>
        <div className={style.col}>
          <div className={style.textBloc}>
            <EditableText
              tagName="h2"
              className={style.title}
              formattingControls={["bold", "italic"]}
              smartProp="title"
              placeholder={"Entrez un titre"}
            />
            <div className={style.bar} />
            <EditableText
              tagName="div"
              className={style.text}
              formattingControls={["bold", "italic", "link"]}
              smartProp="text"
              placeholder={"Entrez un texte"}
            />
            {isEditing ? (
              <InnerBlocks
                allowedBlocks={["smartfire/button-selection"]}
                template={[["smartfire/button-selection", {}]]}
                templateLock="all"
              />
            ) : (
              <ChildrenBlock />
            )}
          </div>
        </div>
        <div className={style.image}>
          <EditableImg smartProp="image" className={style.img} />
        </div>
      </div>
      <div className={separateur ? style.separator : style.disable}>
        <div className={style.bar} />
        <Bouteille />
        <div className={style.bar} />
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.string.withDefault(""),
    text: smartProps.string.withDefault(""),
    image: smartProps.any.withDefault(""),
    disposition: smartProps.string.withDefault("left"),
    separateur: smartProps.bool.withDefault(false),
  },
  setup: {
    title: "Contenu",
    parent: ["smartfire/content-image"],
  },
});
